<template>
    <el-dialog :visible.sync="visible" title="历史成绩排行" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-table  :data="dataList" border>

            <el-table-column prop="examName" label="考试名称" header-align="center" align="center"></el-table-column>
            <el-table-column prop="ranked" label="排行" header-align="center" align="center"></el-table-column>
            <el-table-column prop="teacherName" label="任课教师" header-align="center" align="center"></el-table-column>

        </el-table>
    </el-dialog>
</template>

<script>
export default {
  name: 'history-ranked',
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/exam/examClass/getHistoryClassAverage',
        getDataListIsPage: true,
        deleteIsBatch: true
      },
      visible: false,

      dataForm: {
        classId: '',
        courseId: ''
      },
      dataList: []

    }
  },
  watch: {
  },
  mounted () {

  },
  methods: {
    init () {
      this.visible = true
      this.$http.get('/exam/examClass/getHistoryClassAverage/', {
        params: {
          classId: this.dataForm.classId,
          courseId: this.dataForm.courseId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        //  console.log(res)
        this.dataList = res.data
        console.log(this.dataList)
      }).catch(() => {
      })
    }
  }
}
</script>
